var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getProgress } from './progress';
/**
 * Collect the result of a DETACHED server job (level generation, translation).
 *
 * Those runs take minutes, and a request held open that long does not survive
 * production's reverse proxy — Cloudflare drops an origin request at ~100 s with
 * a 524 while the server happily keeps working, so the author was told it failed.
 * The server therefore answers 202 { accepted, progressId } straight away and
 * reports completion — final payload included — through the progress registry
 * that already drives the progress bar. This polls it and resolves/throws just
 * like the old in-request call did.
 */
// Both generate/publishing dialogs read `err.response.data.{message, code}` —
// shape a job failure the same way so their error handling stays unchanged.
function jobError(message, code) {
    const err = new Error(message);
    err.response = { data: Object.assign({ message }, (code ? { code } : {})) };
    return err;
}
const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
/** True when the server accepted the job instead of running it in-request. */
export function isAccepted(response) {
    return !!(response === null || response === void 0 ? void 0 : response.accepted);
}
export function pollJob(progressId, lostMessage, 
/** Called on every poll that lands, so a caller can show the current stage. */
onProgress) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        for (let misses = 0;;) {
            yield sleep(1200);
            let job;
            try {
                job = yield getProgress(progressId);
                misses = 0;
                onProgress === null || onProgress === void 0 ? void 0 : onProgress({ label: job.label, done: job.done, total: job.total });
            }
            catch (_b) {
                // A brief blip (or the record not written yet) is fine; an id unknown for
                // ~30 s straight means the job is genuinely gone (server restart mid-run).
                if (++misses >= 25)
                    throw jobError(lostMessage);
                continue;
            }
            if (job.status === 'done')
                return job.result;
            if (job.status === 'error') {
                throw jobError((_a = job.message) !== null && _a !== void 0 ? _a : 'The job failed. Please try again later.', job.code);
            }
        }
    });
}
